import { isNil, isString, isPlainObject } from 'lodash/lang';

/**
 * Gets the avatar url, if available
 *
 * @param {Object} user
 * @returns {String|null}
 */
export default function getAvatar(user) {
  if (isNil(user)) {
    return null;
  }

  if (isString(user.avatar_url)) {
    return user.avatar_url;
  }

  if (isString(user.avatar)) {
    return user.avatar;
  }

  if (isPlainObject(user.avatar)) {
    return user.avatar.url;
  }

  return null;
}
